const Colors = {
  primary: '#347af6',
  success: '#2eca9c',
  warning: '#f7c244',
  error: '#ea7874',

  lightGrey: '#bdbdbd',
  darkGrey: '#584F60',
};

export default Colors;
